import { render, staticRenderFns } from "./carLgsForm.vue?vue&type=template&id=412b1973"
import script from "./carLgsForm.vue?vue&type=script&lang=js"
export * from "./carLgsForm.vue?vue&type=script&lang=js"
import style0 from "./carLgsForm.vue?vue&type=style&index=0&id=412b1973&prod&lang=css"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports